module.exports = __webpack_public_path__ + "img/lucky777btn.6fdd4001.png";